let Page      = require('../mixins/base-page');
let htmlClass = require('../mixins/html-class-toggle');

module.exports = {
	mixins: [Page, htmlClass],

	props: {
		loadTab: {
			type: String,
			default: 'overview'
		}
	},
	
	data() {
		return {
			activeTab: this.loadTab	
		}
	},
	
	methods: {
		navigate(selected){
			if(selected !== 'overview')
				location.href = '/my-book/' + selected;
			else
				location.href = '/my-book';
		}
	}
}
